<template>
  <v-tooltip
    :top="position === TOP"
    :right="position === RIGHT"
    :left="position === LEFT"
    :bottom="position === BOTTOM"
    :disabled="disabled"
    z-index="1000"
    :color="color"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot :on="on" :attrs="attrs"></slot>
    </template>
    <span :class="contentClass"> {{ name }}</span>
  </v-tooltip>
</template>

<script>
/**
 * Displays tooltip
 */
export default {
  name: "Tooltip",
  /**
   * ---------------- Data Properties ------------------
   */
  data() {
    const [TOP, RIGHT, LEFT, BOTTOM] = ["top", "right", "left", "bottom"];
    return {
      TOP,
      RIGHT,
      LEFT,
      BOTTOM,
    };
  },
  /**
   * ---------------- Props ------------------
   */
  props: {
    /**
     * Name of the tooltip
     */
    name: {
      type: String,
      required: true,
      default: "Tooltip",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Postion of the tooltip
     * @values top, right, left
     */
    position: {
      type: String,
      default: "top",
    },
    /**
     * Tooltip content class
     * @field name
     */
    contentClass: {
      type: String,
      default: "",
    },
    type: { type: String, default: "default" },
  },
  computed: {
    color() {
      const { colors, type } = this.$appConfig.tooltip;

      switch (this.type) {
        case type.dark:
          return colors.dark;

        default:
          return colors.default;
      }
    },
  },
};
</script>
